module.exports = __webpack_public_path__ + "static/media/IMG_1666.3e3649b7.JPG";